import { render } from "./DynamicMenu.vue?vue&type=template&id=2d2c6937"
import script from "./DynamicMenu.vue?vue&type=script&lang=js"
export * from "./DynamicMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__